import React from "react";
import { useCurrency, CURRENCIES } from "../context/CurrencyContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export function CurrencySelector({ className = "" }) {
  const { currency, changeCurrency } = useCurrency();

  return (
    <Select value={currency} onValueChange={changeCurrency}>
      <SelectTrigger className={`w-[100px] h-8 text-xs border-[#1b2236] bg-white text-[#1b2236] font-semibold ${className}`}>
        <SelectValue>
          {CURRENCIES[currency]?.symbol} {currency}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {Object.entries(CURRENCIES).map(([code, { symbol, name }]) => (
          <SelectItem key={code} value={code} className="text-xs">
            <span className="font-medium">{symbol}</span> {code} - {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
